/*@ngInject*/
const DragAndDropDomManagerDirective = function ($document, formViewerConstant) {

    let linkFunction = function ($scope, $elm, $attr) {

        const mouseTargetClass = 'dragAndDropMouseTarget';

        let mouseTarget;
        let fieldStructureId;
        let targetElement;

        function addTargetDebuggingElements() {
            let mouseTargetTpl = `<div class="${ mouseTargetClass }"></div>`;
            let topDropAreaTpl = '<div class="topZone"></div>';
            let bottomDropAreaTpl = '<div class="bottomZone"></div>';

            targetElement.append(mouseTargetTpl);
            targetElement.append(topDropAreaTpl);
            targetElement.append(bottomDropAreaTpl);

            mouseTarget = $('.' + mouseTargetClass);
        }

        function updateMouseTargetPosition(xValue, yValue) {
            mouseTarget.css('left', xValue + 'px');
            mouseTarget.css('top', yValue + 'px');
        }

        function resetScreen () {
            targetElement.find('.' + mouseTargetClass).remove();
            targetElement.find('.topZone').remove();
            targetElement.find('.bottomZone').remove();

            fieldStructureId = null;
        }

        let resetDebuggerInfo = () => {
            let mouseTarget = element.find('.mouseTarget'),
                debuggerXVal = $('.formViewerContainer .debuggingDragAndDropContainer .xVal'),
                debuggerYVal = $('.formViewerContainer .debuggingDragAndDropContainer .yVal'),
                debuggerDropTypeVal = $('.formViewerContainer .debuggingDragAndDropContainer .dropTypeVal');

            mouseTarget.css('top', '0px');
            mouseTarget.css('left', '0px');
            mouseTarget.css('display', 'none');

            debuggerXVal.html('');
            debuggerYVal.html('');
            debuggerDropTypeVal.html('');
        };

        $scope.$on(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT, (event, debuggerInfo) => {

            if(debuggerInfo.fieldStructureId !== fieldStructureId) {
                fieldStructureId = debuggerInfo.fieldStructureId;
                targetElement = $('.' + fieldStructureId);

                resetScreen();
                addTargetDebuggingElements();
            }

            updateMouseTargetPosition(debuggerInfo.xValue, debuggerInfo.yValue);

        });

        $scope.$on(formViewerConstant.configuration.event.DRAG_FORM_ELEMENT_END, () => {
            resetScreen();
        });

        $scope.$on('$destroy', () => {
            resetScreen();
        });

    };

    return {
        link: linkFunction,
        scope: {},
        restrict: 'E'
    };
};

angular.module('umFormViewer')
    .directive('umDragAndDropDomManager', DragAndDropDomManagerDirective);
